import { FC } from 'react';

enum IconType {
  FLATICON,
  IMAGE
}

interface MarketingSourceLogoDto {
  marketingSource: string;
  path: string;
  iconType: IconType;
}

const marketingSourceLogos: MarketingSourceLogoDto[] = [
  {
    marketingSource: 'Direct',
    iconType: IconType.FLATICON,
    path: 'ra-icons-marketing-login'
  },
  {
    marketingSource: 'Email',
    iconType: IconType.FLATICON,
    path: 'ra-icons-generic-envelope-2'
  },
  {
    marketingSource: 'Sms',
    iconType: IconType.FLATICON,
    path: 'ra-icons-device-smartphone'
  },
  {
    marketingSource: 'Referral',
    iconType: IconType.FLATICON,
    path: 'ra-icons-generic-forward'
  },
  {
    marketingSource: 'UnMatched',
    iconType: IconType.IMAGE,
    path: '/media/misc/unmatched.png'
  },
  {
    marketingSource: 'Offline',
    iconType: IconType.IMAGE,
    path: '/media/misc/offline.png'
  },
  {
    marketingSource: 'Offline - Trade Show',
    iconType: IconType.IMAGE,
    path: '/media/misc/offline.png'
  },
  {
    marketingSource: 'AdRoll Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/adroll-logo.png'
  },
  {
    marketingSource: 'AdRoll Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/adroll-logo.png'
  },
  {
    marketingSource: 'Awin Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/awin-logo.png'
  },
  {
    marketingSource: 'Awin Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/awin-logo.png'
  },
  {
    marketingSource: 'Awin',
    iconType: IconType.IMAGE,
    path: '/media/logos/awin-logo.png'
  },
  {
    marketingSource: 'Bing Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/bing-logo.png'
  },
  {
    marketingSource: 'Bing Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/bing-logo.png'
  },
  {
    marketingSource: 'DuckDuckGo Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/duckduckgo-logo.png'
  },
  {
    marketingSource: 'Facebook Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/facebook-logo.png'
  },
  {
    marketingSource: 'Facebook Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/facebook-logo.png'
  },
  {
    marketingSource: 'Google Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/google-logo.png'
  },
  {
    marketingSource: 'Google Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/google-ads-logo.png'
  },
  {
    marketingSource: 'Google Places',
    iconType: IconType.IMAGE,
    path: '/media/logos/google-maps-icon.png'
  },
  {
    marketingSource: 'Instagram Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/instagram-logo.png'
  },
  {
    marketingSource: 'Instagram Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/instagram-logo.png'
  },
  {
    marketingSource: 'LinkedIn Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/linkedin-logo.png'
  },
  {
    marketingSource: 'LinkedIn Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/linkedin-logo.png'
  },
  {
    marketingSource: 'Outbrain Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/outbrain-logo.png'
  },
  {
    marketingSource: 'Outbrain Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/outbrain-logo.png'
  },
  {
    marketingSource: 'Outbrain',
    iconType: IconType.IMAGE,
    path: '/media/logos/outbrain-logo.png'
  },
  {
    marketingSource: 'Pinterest Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/pinterest-logo.png'
  },
  {
    marketingSource: 'Pinterest Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/pinterest-logo.png'
  },
  {
    marketingSource: 'Reddit Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/reddit-logo.png'
  },
  {
    marketingSource: 'Reddit Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/reddit-logo.png'
  },
  {
    marketingSource: 'Snapchat Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/snapchat-logo.png'
  },
  {
    marketingSource: 'Snapchat Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/snapchat-logo.png'
  },
  {
    marketingSource: 'StackAdapt Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/stackadapt-logo.png'
  },
  {
    marketingSource: 'StackAdapt Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/stackadapt-logo.png'
  },
  {
    marketingSource: 'StackAdapt',
    iconType: IconType.IMAGE,
    path: '/media/logos/stackadapt-logo.png'
  },
  {
    marketingSource: 'TikTok Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/tiktok-logo.png'
  },
  {
    marketingSource: 'TikTok Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/tiktok-logo.png'
  },
  {
    marketingSource: 'Twitter Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/twitter-logo.png'
  },
  {
    marketingSource: 'Twitter Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/twitter-logo.png'
  },
  {
    marketingSource: 'Yahoo Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/yahoo-logo.png'
  },
  {
    marketingSource: 'Yahoo Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/yahoo-logo.png'
  },
  {
    marketingSource: 'YouTube Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/youtube-logo.png'
  },
  {
    marketingSource: 'YouTube Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/youtube-logo.png'
  },
  {
    marketingSource: 'Klaviyo Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/klaviyo-logo.png'
  },
  {
    marketingSource: 'Criteo Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/criteo-logo.png'
  },
  {
    marketingSource: 'Impact Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/impact-logo.png'
  },
  {
    marketingSource: 'ShareASale Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/shareasale-logo.png'
  },
  {
    marketingSource: 'TheTradeDesk Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/thetradedesk-logo.png'
  },
  {
    marketingSource: 'Unassigned',
    iconType: IconType.FLATICON,
    path: 'ra-icons-generic-question-sign'
  },
  {
    marketingSource: 'Taboola Paid',
    iconType: IconType.IMAGE,
    path: '/media/logos/taboola-logo.png'
  },
  {
    marketingSource: 'Moneypenny Answered',
    iconType: IconType.IMAGE,
    path: '/media/logos/moneypenny-logo.png'
  },
  {
    marketingSource: 'Moneypenny Not Answered',
    iconType: IconType.IMAGE,
    path: '/media/logos/moneypenny-logo.png'
  },
  {
    marketingSource: 'ChatGPT Organic',
    iconType: IconType.IMAGE,
    path: '/media/logos/chatgpt-logo.png'
  }
];

const MarketingSourceLogo: FC<{
  marketingSource: string;
  imageClasses?: string;
  iconClasses?: string;
}> = ({
  marketingSource,
  imageClasses,
  iconClasses
}: {
  marketingSource: string;
  imageClasses?: string;
  iconClasses?: string;
}) => {
  const logoToUse = marketingSourceLogos.find(
    (icon) => icon.marketingSource === marketingSource
  );

  return logoToUse ? (
    <>
      {logoToUse.iconType === IconType.FLATICON ? (
        <i
          className={`${logoToUse.path} ${iconClasses}`}
          title={marketingSource}
        ></i>
      ) : (
        <img
          src={logoToUse.path}
          className={imageClasses}
          alt={logoToUse.marketingSource}
          title={marketingSource}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default MarketingSourceLogo;
